import { MetricCardsGrid, MetricCard } from "@/components/common/MetricCards";
import { ClaimItem } from "@/types";
import { useRecordContext } from "react-admin";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DatePaidIcon from "@mui/icons-material/Payment";
import PaymentsIcon from "@mui/icons-material/Payments";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { formatDateRange, formatDate, DATE_FORMATS } from "@/utils/formatters/dateFormatter";
import { formatUSD } from "@/utils/formatters/currencyFormatter";

export const ClaimItemMetrics = () => {
  const record = useRecordContext<ClaimItem>();

  const {
    date_of_service_start,
    date_of_service_end,
    date_of_service,
    paid_date,
    paid_amount,
    billed_amount,
    eligible_amount,
  } = record ?? {};

  const sharedIconStyle = { fontSize: 18, color: "primary.main" };

  const getServiceDateDisplay = () => {
    if (date_of_service_start || date_of_service_end) {
      return formatDateRange(date_of_service_start as string, date_of_service_end as string, DATE_FORMATS.DISPLAY);
    }
    if (date_of_service) {
      return formatDate(String(date_of_service), DATE_FORMATS.DISPLAY);
    }
    return "N/A";
  };

  return (
    <MetricCardsGrid columns={4}>
      <MetricCard
        icon={<PaymentsIcon sx={sharedIconStyle} />}
        title="Paid Amount"
        value={paid_amount ? formatUSD(paid_amount) : "N/A"}
        subMetrics={
          billed_amount || eligible_amount
            ? [
                ...(billed_amount ? [{ label: "Billed", value: formatUSD(billed_amount) }] : []),
                ...(eligible_amount ? [{ label: "Eligible", value: formatUSD(eligible_amount) }] : []),
              ]
            : undefined
        }
      />
      <MetricCard icon={<DateRangeIcon sx={sharedIconStyle} />} title="Service Date" value={getServiceDateDisplay()} />
      <MetricCard
        icon={<DatePaidIcon sx={sharedIconStyle} />}
        title="Paid Date"
        value={paid_date ? formatDate(paid_date as string, DATE_FORMATS.DISPLAY) : "N/A"}
      />
      <MetricCard
        icon={<CheckCircleIcon sx={sharedIconStyle} />}
        title="Eligibility"
        value={record?.is_eligible ? "Eligible" : "Ineligible"}
      />
    </MetricCardsGrid>
  );
};
